import React, { lazy, Suspense, useEffect } from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { store } from '~/initializeStore';
import AuthChecker from './components/AuthChecker/AuthChecker';
import Auth from './pages/Auth/Auth';
import ProtectedRoute from '~/components/ProtectedRoute/ProtectedRoute';
const Landing = lazy(() => import('~/pages/Landing/Landing'));
import { useTranslation } from 'react-i18next';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import CookieConsentBanner from '~/components/CookieConsentBanner/CookieConsentBanner';
const Dashboard = lazy(() => import('~/pages/Dashboard/Dashboard'));
const ExternalUpload = lazy(() => import('~/pages/ExternalUpload/ExternalUpload'));
const PrivacyPolicy = lazy(() => import('~/pages/PrivacyPolicy/PrivacyPolicy'));
const TermsOfService = lazy(() => import('~/pages/TermsOfService/TermsOfService'));

const ProtectedApp = () => (
  <AuthChecker>
    <Switch>
      <Route path="/auth" component={Auth} />
      <Route exact path="/" component={Landing} />
      <ProtectedRoute path="/" component={Dashboard} />
    </Switch>
  </AuthChecker>
);

const AppRoutes = () => (
  <Switch>
    <Route path="/upload/:token" component={ExternalUpload} />
    <Route path="/privacy-policy" component={PrivacyPolicy} />
    <Route path="/terms-of-service" component={TermsOfService} />
    <Route component={ProtectedApp} />
  </Switch>
);

const Routes = () => {
  return (
    <>
      <Suspense fallback={<FullPageLoader />}>
        <Route path="/" component={AppRoutes} />
      </Suspense>
    </>
  );
};

function App() {
  const { i18n } = useTranslation('common');

  useEffect(() => {
    if (['pl', 'en'].includes(i18n.language) || !i18n.language) {
      return;
    }
    const [lang] = i18n.language.split('-');
    i18n.changeLanguage(lang || 'en');
  }, [i18n]);

  return (
    <Provider store={store}>
      <Router>
        <Routes />
        <CookieConsentBanner />
      </Router>
    </Provider>
  );
}

export default App;
